import React from 'react';
import { Card, CardContent, CardHeader } from '@/Components/ui/card';
import { Badge } from '@/Components/ui/badge';
import { Button } from '@/Components/ui/button';
import { Separator } from '@/Components/ui/separator';
import { Stack } from '@/Components/ui/layout';
import { Heading } from '@/Components/ui/typography';
import { Text } from '@/Components/ui/typography';
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

export const PricingCard = ({ title, price, features, isRecommended }) => {
  return (
    <Card className={cn(
      "w-[312px] min-h-[493px] flex flex-col pb-6 relative",
      isRecommended && "border-[#0a65cc] shadow-lg"
    )}>
      {isRecommended && (
        <Badge className="absolute -top-5 left-1/2 -translate-x-1/2 bg-[#0a65cc] text-white px-3 py-1 rounded-t-md rounded-b-none text-sm font-medium">
          Recommendation
        </Badge>
      )}
      <CardHeader className="p-6 inline-block -mt-6">
        <Stack spacing="sm">
          <Heading level="h3" className="text-base font-medium text-foreground mb-1.5">
            {title}
          </Heading>
          <Text size="sm" className="text-muted-foreground leading-[18px]">
            Praesent eget pulvinar orci. Duis ut pellentesque ligula convalis.
          </Text>
          <div className="flex items-baseline gap-1">
            <span className="text-[#0a65cc] text-4xl font-medium">${price}</span>
            <span className="text-muted-foreground/70 text-base">/Monthly</span>
          </div>
        </Stack>
      </CardHeader>
      <Separator className={cn(
        "my-3",
        isRecommended && "bg-[#0a65cc]"
      )} />
      <CardContent className="px-6 flex-1 flex flex-col">
        <ul className="flex flex-col gap-4 list-none m-2.5">
          {features.map((feature, index) => (
            <li key={index} className="flex items-center gap-2 text-foreground/80 text-sm">
              <Check className="w-5 h-5 text-primary flex-shrink-0" />
              <span>{feature}</span>
            </li>
          ))}
        </ul>
        <Button
          className={cn(
            "mt-auto mx-6 flex items-center justify-center gap-3 rounded-sm py-3 px-6 text-base font-semibold",
            isRecommended
              ? "bg-[#0a65cc] text-white hover:bg-[#0a65cc]/90"
              : "bg-[#e7f0fa] text-[#0a65cc] hover:bg-[#e7f0fa]/80"
          )}
        >
          <span>Choose plan</span>
        </Button>
      </CardContent>
    </Card>
  );
};
